import styled from 'styled-components';
import { Button } from 'src/components/common/Button';
import { useTranslate } from 'react-t7e';
import { media } from 'src/styles/designs';
import { motion } from 'framer-motion';
import { makeTransition } from 'src/utils/motion/transitions';
import { DispatchOnClick } from 'src/components/common/DispatchOnClick';
import { useContext } from 'react';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';

interface EventPagePopupProps {
  timeslotIds: string[];
  onComplete: () => void;
}

const EventPagePopupContainer = styled.div`
  position: fixed;
  z-index: 90;
  bottom: 0;
  left: 0;
  right: 0;

  ${media.w.greaterThanOrEqual.desktop} {
    left: calc(50% - (var(--scrollbar-padding) / 2));
    transform: translateX(-50%);
    width: 750px;
    max-width: 100%;
    bottom: 10vh;
    right: unset;
  }
`;

const EventPagePopup = styled(motion.div)`
  position: relative;
  background-color: #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  box-shadow: 0 13px 9px 0 rgba(0, 0, 0, 0.35);
  color: white;
  gap: 16px;

  ${media.w.lessThan.desktop} {
    box-shadow: 0 -13px 9px 0 rgba(0, 0, 0, 0.35);

    padding: 20rpx;
    height: 110px;

    .btn {
      min-width: 0;
      flex: 1 1 auto;
    }
  }
`;

const EventPagePopupText = styled.div`
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  word-break: keep-all;
  white-space: nowrap;

  ${media.w.lessThan.desktop} {
    font-size: 14px;
  }
`;

export const EventPageSignupPopup = ({
  onComplete,
  timeslotIds,
}: EventPagePopupProps) => {
  const { _n, _ } = useTranslate();
  const { event } = useContext(EventPageContext);

  return (
    <EventPagePopupContainer>
      <EventPagePopup {...makeTransition({ fade: true, from: 'bottom' })}>
        <EventPagePopupText>
          {_n(
            'Joining {sessions} session',
            'Joining {sessions} sessions',
            timeslotIds.length,
            undefined,
            {
              sessions: timeslotIds.length,
            },
          )}
        </EventPagePopupText>
        <DispatchOnClick
          type="modalOpen"
          payload={{
            kind: 'eventSignup',
            timeslotIds,
            eventId: event.id,
            onComplete,
          }}
        >
          <Button variant="inverted">{_('Sign up')}</Button>
        </DispatchOnClick>
      </EventPagePopup>
    </EventPagePopupContainer>
  );
};
